export interface ItemListadoPreguntas {
    nombre: string;
    abreviacion: string;
}

export const itemsListadoPreguntas: ItemListadoPreguntas[] = [
    { nombre: "Funnel", abreviacion: "F" },
    { nombre: "Cuotas", abreviacion: "C" },
    { nombre: "Rangos de edad", abreviacion: "R" },
    { nombre: "Géneros", abreviacion: "G" },
    { nombre: "Países", abreviacion: "P" },
    { nombre: "Por día", abreviacion: "D" }
];
